export const KLEVU_CUSTOM_FILTER_FILTER_SORTING: string[] = ["category"];
